import { withInstall } from '@tw-element/utils'

import ImageViewer from './src/image-viewer.vue'

export const TwImageViewer = withInstall(ImageViewer)
export default TwImageViewer

export * from './src/image-viewer'
